export const news = [
  {
    id: "news-001",
    title: "《长安烟雨录》收视口碑双丰收，权谋群像再掀古装热潮",
    date: "2025-10-11",
    category: "剧集新闻",
    summary:
      "开播三周以来，《长安烟雨录》凭借缜密的权谋线与细腻的人物刻画稳居热度榜首，观众纷纷称赞其“全员演技在线”。",
    content: [
      "由陈望舒执导，林清月、沈砚舟领衔主演的古装权谋剧《长安烟雨录》自开播以来热度持续攀升，连续多日位居全网剧集热度榜前列。",
      "该剧以一场连绵烟雨为引，讲述女官苏衡因一卷密档卷入朝堂纷争的故事。剧集摒弃了以往古装剧常见的快节奏爽感，转而以扎实的推理和人物关系的层层铺陈见长，被观众评价为“需要动脑子的古装剧”。",
      "主演林清月在采访中表示，为了演好苏衡这个角色，她提前两个月研读剧本，并查阅了大量关于唐代官制的资料。“苏衡不是完美的角色，她的犹豫和成长才是最有意思的部分。”",
      "业内人士认为，《长安烟雨录》的成功再次证明了扎实剧本与群像塑造对古装题材的重要性，也为后续同类作品的创作提供了参考。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20behind%20the%20scenes%20news%20banner%2C%20ancient%20palace%20corridor%20with%20warm%20lanterns%20and%20soft%20mist%2C%20cinematic%20wide%20shot&width=800&height=450&seq=news-changan-ratings-01&orientation=landscape",
  },
  {
    id: "news-002",
    title: "悬疑剧《深巷之光》定档，法医+刑警组合引发期待",
    date: "2025-10-09",
    category: "剧集新闻",
    summary:
      "罗清野执导的悬疑剧《深巷之光》正式公布定档信息，苏晚晴与顾南亭的“法医刑警”组合成为讨论焦点。",
    content: [
      "备受关注的悬疑剧《深巷之光》宣布定档，主创团队同时放出了首支正式预告。预告中冷峻的影像风格与紧凑的线索剪辑，让不少悬疑爱好者直呼“质感拉满”。",
      "该剧由罗清野执导，苏晚晴饰演法医程知微，顾南亭饰演刑警队长宋野。两人此前曾在多部作品中合作，此次的“专业搭档”组合被观众寄予厚望。",
      "导演罗清野透露，剧组为还原真实的刑侦流程，特别邀请了顾问团队参与剧本打磨，“我们希望每一个细节都经得起推敲，让观众跟着角色一起破案。”",
      "随着定档信息的公布，《深巷之光》相关话题迅速登上社交平台热搜，成为本季度最受期待的悬疑剧之一。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=Suspense%20drama%20news%20banner%2C%20dark%20narrow%20alley%20at%20night%20with%20a%20single%20street%20lamp%20glowing%2C%20moody%20cinematic%20wide%20shot&width=800&height=450&seq=news-alley-light-premiere-01&orientation=landscape",
  },
  {
    id: "news-003",
    title: "演员动态 | 江北辰凭《大漠孤烟》完成动作戏突破",
    date: "2025-10-07",
    category: "演员动态",
    summary:
      "在武侠剧《大漠孤烟》中，江北辰亲自完成了多场高难度武打戏份，业内评价其“打戏干净利落，颇具老派武侠风骨”。",
    content: [
      "武侠剧《大漠孤烟》正在热播，剧中江北辰饰演的剑客沈孤鸿凭借凌厉的身手和克制的表演收获大量好评。",
      "据剧组透露，江北辰为该剧进行了长达三个月的武术训练，多场沙漠中的打戏均为亲自上阵，未使用替身。他在采访中坦言：“武侠是小时候的梦，这次算是圆梦了。”",
      "动作导演评价称，江北辰的动作“干净利落，有分寸感”，在当下的年轻演员中难能可贵。",
      "《大漠孤烟》目前更新至 30 集，剧情即将进入高潮阶段，沈孤鸿的身世之谜也将在后续揭晓。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=Wuxia%20drama%20news%20banner%2C%20lone%20swordsman%20silhouette%20on%20desert%20dunes%20at%20golden%20sunset%2C%20epic%20cinematic%20wide%20shot&width=800&height=450&seq=news-jiang-action-01&orientation=landscape",
  },
  {
    id: "news-004",
    title: "行业观察：2025 年国产剧题材多元化趋势明显",
    date: "2025-10-05",
    category: "行业动态",
    summary:
      "从古装权谋到悬疑罪案，从都市职场到家庭温情，2025 年的国产剧市场呈现出题材百花齐放的态势。",
    content: [
      "回顾 2025 年已播出的剧集，一个明显的变化是题材分布的多元化。传统的都市情感剧依然占据一定的市场份额，但悬疑、古装、职场、家庭等品类的占比显著提升。",
      "平台数据显示，观众对“强类型”剧集的接受度越来越高。以往被认为“小众”的悬疑和犯罪题材，如今已成为拉动播放量的重要力量。",
      "与此同时，剧集制作水准的整体提升也为题材多元化提供了基础。越来越多的作品在美术、摄影和配乐上投入更多精力，追求“电影感”的视听体验。",
      "有分析指出，观众审美正在从“看明星”向“看故事”转变，这对创作者而言既是机遇也是挑战。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20media%20industry%20news%20banner%2C%20abstract%20grid%20of%20glowing%20screens%20and%20film%20frames%2C%20deep%20blue%20and%20warm%20orange%20tones%2C%20clean%20cinematic&width=800&height=450&seq=news-industry-2025-01&orientation=landscape",
  },
  {
    id: "news-005",
    title: "《硅谷玫瑰》聚焦女性职场，创业题材再受关注",
    date: "2025-10-03",
    category: "剧集新闻",
    summary:
      "现代职场剧《硅谷玫瑰》以女性工程师创业为主线，引发关于职场性别与创业生态的广泛讨论。",
    content: [
      "由程越执导，温之夏、陆行舟主演的《硅谷玫瑰》正在热播。该剧以海归工程师周妍回国创业为切入点，展现了科技行业中的竞争与合作。",
      "剧集没有回避职场中的现实矛盾，女性在技术行业面临的质疑、资本与理想的博弈等议题都被纳入叙事之中，引发了观众的共鸣与讨论。",
      "编剧团队表示，创作过程中采访了多位真实的创业者和工程师，“我们想写的不是爽文式的成功，而是一个有血有肉的成长过程。”",
      "截至目前，《硅谷玫瑰》的口碑稳步上升，被不少观众评价为“近年少有的不悬浮的职场剧”。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20workplace%20drama%20news%20banner%2C%20glass%20office%20tower%20interior%20at%20dusk%20with%20blue%20and%20warm%20light%2C%20sleek%20cinematic%20wide%20shot&width=800&height=450&seq=news-silicon-workplace-01&orientation=landscape",
  },
  {
    id: "news-006",
    title: "剧情解析 | 《都市迷航》前二十集埋下了哪些伏笔？",
    date: "2025-10-01",
    category: "剧情解析",
    summary:
      "作为本季口碑黑马，《都市迷航》在细节中埋下了大量线索。本文为你梳理那些可能被忽略的关键伏笔。",
    content: [
      "《都市迷航》播出过半，围绕江屿与温晚的调查，剧情逐步揭开冰山一角。但细心的观众会发现，许多关键信息早在前期就以不起眼的方式出现过。",
      "第一处伏笔出现在首集：失踪者家中墙上那张被撕掉一半的照片，其背景与三年前旧案的现场高度相似。这一细节在后来的调查中被反复印证。",
      "第二处值得注意的，是江屿反复出现的梦境。梦境中模糊的场景并非随意设计，而是与后续线索一一对应，暗示着他与旧案之间更深的联系。",
      "此外，剧中多次出现的时钟特写也并非单纯的氛围营造。每一次时间定格，都对应着案件推进的关键节点，构成了一条隐秘的时间线。",
      "随着结局临近，这些伏笔能否被一一回收，将成为检验该剧编剧功力的关键。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=Urban%20thriller%20analysis%20news%20banner%2C%20rainy%20city%20street%20at%20night%20with%20reflected%20neon%20lights%2C%20cool%20blue%20tones%20with%20amber%20accents&width=800&height=450&seq=news-city-analysis-01&orientation=landscape",
  },
  {
    id: "news-007",
    title: "《山河故人梦》收官，年代剧如何打动年轻观众？",
    date: "2025-09-28",
    category: "剧情解析",
    summary:
      "一部讲述三十年前家庭故事的年代剧，却收获了大量年轻观众。它究竟做对了什么？",
    content: [
      "《山河故人梦》迎来收官，这部横跨三十年时光的年代家庭剧，出人意料地吸引了大批年轻观众。",
      "剧集并没有刻意渲染苦难，也不追求戏剧化的冲突，而是把重点放在一家人日常的相处与细微的情感变化上。正是这种克制的表达，让不同年龄层的观众都能从中找到共鸣。",
      "有观众留言说：“看完之后给爸妈打了个电话。”这种真实的情感触动，或许正是年代剧穿越时间的价值所在。",
      "从创作角度看，《山河故人梦》的成功也说明，年代题材并非只能面向中老年观众，真诚的故事永远拥有跨代际的感染力。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=Nostalgic%20period%20drama%20news%20banner%2C%20southern%20Chinese%20old%20town%20at%20warm%20sunset%2C%20sepia%20tones%2C%20nostalgic%20cinematic%20wide%20shot&width=800&height=450&seq=news-mountain-finale-01&orientation=landscape",
  },
  {
    id: "news-008",
    title: "演员动态 | 温之夏谈《星辰与你》：想演出普通人的光",
    date: "2025-09-24",
    category: "演员动态",
    summary:
      "从治愈爱情到职场成长，温之夏近年的角色都带着一种真实的力量。这一次，她聊了聊自己对表演的理解。",
    content: [
      "在《星辰与你》中，温之夏饰演的天文台研究员沈星，是许多观众心中的“白月光”。她形容这个角色“安静但固执，像一颗遥远的星”。",
      "谈到表演，温之夏表示自己越来越偏爱“普通人”的角色。“我不想演完美的人，我想演出普通人在生活里的那点光，那点坚持。”",
      "从《春风十里长街》的咖啡店老板到《硅谷玫瑰》的创业工程师，温之夏饰演的角色都在认真地面对生活，这种一致性也让她的表演形成了独特的气质。",
      "她透露，接下来希望能尝试更有挑战性的题材，“想看看自己还能走多远。”",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=Actress%20interview%20news%20banner%2C%20soft%20portrait%20of%20a%20young%20woman%20near%20a%20window%20with%20warm%20daylight%2C%20gentle%20cream%20and%20soft%20blue%20tones&width=800&height=450&seq=news-wenzhixia-interview-01&orientation=landscape",
  },
];